import styled from 'styled-components'
import tw from 'tailwind.macro'

const StSep1 = styled.div`
  ${tw`border-gray-300 my-4 font-bold block leading-tight`}
  border-bottom-width: 1px;
  border-style: solid;
`

export { StSep1 }
